(function () {
  'use strict';

  // ─── Inject styles once ───────────────────────────────────────────────────
  if (!document.getElementById('gift-message-styles')) {
    var style = document.createElement('style');
    style.id = 'gift-message-styles';
    style.textContent = [
      '.gift-message-widget { margin-bottom: 1rem; }',

      '.gift-message-toggle {',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: space-between;',
      '  width: 100%;',
      '  padding: 0.9rem 1.1rem;',
      '  background: transparent;',
      '  border: 1.5px dashed currentColor;',
      '  border-radius: 4px;',
      '  cursor: pointer;',
      '  font-size: 14px;',
      '  font-weight: 600;',
      '  text-align: left;',
      '  gap: 0.5rem;',
      '  transition: background 0.2s ease;',
      '  font-family: "Cabin", sans-serif;',
      '}',

      '.gift-message-toggle:hover { background: rgba(0,0,0,0.04); }',

      '.gift-toggle-arrow {',
      '  display: inline-block;',
      '  transition: transform 0.25s ease;',
      '  font-size: 0.7rem;',
      '  flex-shrink: 0;',
      '}',

      '.gift-message-toggle[aria-expanded="true"] .gift-toggle-arrow {',
      '  transform: rotate(180deg);',
      '}',

      '.gift-message-accordion {',
      '  overflow: hidden;',
      '  max-height: 0;',
      '  transition: max-height 0.3s ease, opacity 0.25s ease;',
      '  opacity: 0;',
      '}',

      '.gift-message-accordion.is-open {',
      '  max-height: 260px;',
      '  opacity: 1;',
      '  padding-top: 0.75rem;',
      '}',

      '.gift-message-label {',
      '  display: block;',
      '  font-size: 14px;',
      '  margin-bottom: 0.4rem;',
      '  font-weight: 500;',
      '  font-family: "Cabin", sans-serif;',
      '}',

      '.gift-message-textarea {',
      '  width: 100%;',
      '  min-height: 90px;',
      '  padding: 0.7rem;',
      '  border: 1px solid #ccc;',
      '  border-radius: 4px;',
      '  font-size: 14px;',
      '  resize: vertical;',
      '  box-sizing: border-box;',
      '  font-family: "Cabin", sans-serif;',
      '}',

      '.gift-message-error {',
      '  margin-top: 0.4rem;',
      '  color: #c00;',
      '  font-size: 14px;',
      '  font-family: "Cabin", sans-serif;',
      '  display: none;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  // ─── Accordion toggles ────────────────────────────────────────────────────
  function initToggles() {
    document.querySelectorAll('[data-gift-toggle]').forEach(function (btn) {
      if (btn._giftToggleInit) return;
      btn._giftToggleInit = true;

      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('data-gift-target');
        var accordion = document.getElementById(targetId);
        if (!accordion) return;

        var isOpen = accordion.classList.contains('is-open');
        accordion.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));

        if (!isOpen) {
          var textarea = accordion.querySelector('textarea');
          if (textarea) setTimeout(function () { textarea.focus(); }, 300);
        }
      });
    });
  }

  // ─── Checkout intercept ───────────────────────────────────────────────────
  function initCheckoutButtons() {
    ['CartDrawer-Checkout', 'checkout'].forEach(function (btnId) {
      var btn = document.getElementById(btnId);
      if (!btn || btn._giftCheckoutInit) return;
      btn._giftCheckoutInit = true;

      var variantId = btn.getAttribute('data-gift-variant-id');
      var textareaId = btn.getAttribute('data-gift-textarea');
      var errorId = btn.getAttribute('data-gift-error');

      if (!variantId || !textareaId) return;

      btn.addEventListener('click', function (e) {
        var textarea = document.getElementById(textareaId);
        var message = textarea ? textarea.value.trim() : '';
        var errorEl = errorId ? document.getElementById(errorId) : null;

        // Hide any previous error
        if (errorEl) errorEl.style.display = 'none';

        if (!message) {
          // No gift message — navigate to checkout directly
          e.preventDefault();
          window.location.href = '/checkout';
          return;
        }

        // Gift message present — prevent default, handle manually
        e.preventDefault();

        var originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = 'Adding gift message&hellip;';

        // 1. Save message to cart attributes
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Gift Note': message } })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart update failed');
            // 2. Check if gift variant already in cart
            return fetch('/cart.js');
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var alreadyInCart = cart.items.some(function (item) {
              return String(item.variant_id) === String(variantId);
            });

            if (alreadyInCart) {
              // Already added — skip to checkout
              return Promise.resolve();
            }

            // 3. Add the $0.99 gift message product
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: Number(variantId), quantity: 1 })
            }).then(function (res) {
              if (!res.ok) {
                return res.json().then(function (err) {
                  throw new Error(err.description || 'Unable to add gift message product.');
                });
              }
            });
          })
          .then(function () {
            // 4. Redirect to checkout
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            console.error('[Gift Message]', err);
            btn.disabled = false;
            btn.innerHTML = originalHTML;
            if (errorEl) {
              errorEl.textContent = err.message || 'Something went wrong. Please try again.';
              errorEl.style.display = 'block';
            }
          });
      });
    });
  }

  // ─── Cart Page: auto-add / auto-remove gift product on textarea change ────
  // Instead of intercepting the checkout button (which depends on knowing a
  // third-party button's selector), we listen to the #gift-note textarea.
  // When a message is typed  → gift product is added to cart immediately.
  // When the message is cleared → gift product is removed.
  // The checkout button (Insurify or original) works completely untouched.
  function initCartPageCheckout() {
    var giftTextarea = document.getElementById('gift-note');
    if (!giftTextarea) return; // Not on cart page — do nothing

    console.log('[Gift Msg] Initializing cart page auto-sync...');

    var GIFT_VARIANT_ID = '42946689040489';
    var _debounceTimer = null;
    var _busy = false;

    function syncGiftProduct() {
      if (_busy) return;
      clearTimeout(_debounceTimer);
      _debounceTimer = setTimeout(function () {
        var message = giftTextarea.value.trim();
        console.log('[Gift Msg] Syncing... Message length:', message.length);

        _busy = true;
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var giftLine = null;
            cart.items.forEach(function (item, i) {
              if (String(item.variant_id) === String(GIFT_VARIANT_ID)) {
                giftLine = i + 1; // 1-indexed cart line
              }
            });

            if (message && !giftLine) {
              // ── Has message, product NOT in cart → ADD ───────────────────
              console.log('[Gift Msg] Adding $0.99 gift product...');
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: Number(GIFT_VARIANT_ID), quantity: 1 })
              }).then(function (res) {
                if (!res.ok) return res.json().then(function (d) { throw new Error(d.description); });
                console.log('[Gift Msg] Gift product added to cart ✓');
              });
            }

            if (!message && giftLine) {
              // ── No message, product IS in cart → REMOVE ──────────────────
              console.log('[Gift Msg] Removing gift product (message cleared)...');
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line: giftLine, quantity: 0 })
              }).then(function (res) {
                if (!res.ok) throw new Error('Remove failed');
                console.log('[Gift Msg] Gift product removed from cart ✓');
              });
            }

            console.log('[Gift Msg] Cart and message are already in sync.');
            // Else: nothing to do (both in sync already)
          })
          .catch(function (err) {
            console.error('[Gift Msg] Sync error:', err.message || err);
          })
          .finally(function () {
            _busy = false;
          });
      }, 800); // debounce — wait 0.8s after last keystroke
    }

    // Listen to every keystroke and change
    giftTextarea.addEventListener('input', syncGiftProduct);
    giftTextarea.addEventListener('change', syncGiftProduct);

    // On page load: if a saved message is already in the textarea, sync now
    // (handles the case where user refreshes the page with an existing message)
    if (giftTextarea.value.trim()) {
      syncGiftProduct();
    }
  }

  function init() {
    initToggles();
    initCheckoutButtons();
  }

  // ─── Bootstrap ────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initCartPageCheckout();
    });
  } else {
    init();
    initCartPageCheckout();
  }

  // Re-init if cart drawer DOM is mutated (e.g. after cart updates)
  document.addEventListener('DOMContentLoaded', function () {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;

    var debounceTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(init, 50);
    });
    observer.observe(cartDrawerEl, { childList: true, subtree: true });
  });
})();

